<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card body-class="py-md-1 px-md-2 py-0 px-1">
          <b-row>
            <b-col
              class="mb-xl-0 mb-md-3 mb-1 px-sm-1 px-0 d-flex justify-content-center align-items-center"
              cols="12"
              xl="4"
            >
              <b-skeleton
                width="300px"
                height="300px"
                v-if="loading"
              ></b-skeleton>

              <div
                v-else
                style="max-height: 250px"
                class="d-flex justify-content-center align-items-center w-100"
              >
                <b-img
                  @error="setAltImg"
                  :src="course.banner || errorImage"
                  fluid
                  :alt="course.name"
                  style="max-height: 250px"
                ></b-img>
              </div>
            </b-col>
            <b-col cols="12" xl="8">
              <b-skeleton
                width="80px"
                height="30px"
                v-if="loading"
              ></b-skeleton>
              <h2 class="font-weight-bold" v-else>{{ course.name }}</h2>
              <b-media no-body>
                <b-media-body
                  class="d-flex flex-wrap justify-content-between w-100 my-1"
                >
                  <b-skeleton
                    width="200px"
                    height="20px"
                    v-if="loading"
                    class="mr-2 mb-1"
                  ></b-skeleton>
                  <div class="d-flex mr-2 mb-1" v-else-if="course.started_at">
                    <span
                      ><feather-icon size="14" icon="CalendarIcon" /> تاریخ شروع
                      :
                    </span>

                    <span>{{ calcDate(course.started_at) || "-" }}</span>
                  </div>
                  <b-skeleton
                    width="200px"
                    height="20px"
                    v-if="loading"
                    class="mr-2 mb-1"
                  ></b-skeleton>

                  <div class="d-flex mr-2 mb-1" v-else-if="course.ended_at">
                    <span
                      ><feather-icon size="14" icon="CalendarIcon" /> تاریخ
                      پایان :
                    </span>

                    <span>{{ calcDate(course.ended_at) }}</span>
                  </div>
                  <b-skeleton
                    width="200px"
                    height="20px"
                    v-if="loading"
                    class="mb-1"
                  ></b-skeleton>

                  <div class="d-sm-flex d-none mb-1" v-else>
                    <span> وضعیت : </span>

                    <b-badge
                      :variant="course.active ? 'success' : 'danger'"
                      class="rounded"
                    >
                      {{ course.active ? "فعال" : "غیر فعال" }}
                    </b-badge>
                  </div>
                  <div class="d-lg-none d-block w-100">
                    <div
                      v-show="
                        !course.bought &&
                        course.can_buy &&
                        availableAtTimer &&
                        availableAtTimer.res
                      "
                    >
                      <div
                        class="d-flex justify-content-sm-between justify-content-center w-100 flex-wrap text-info my-25 font-weight-bold"
                      >
                        <div class="my-25">
                          زمان باقی مانده تا شروع ثبت نام :
                        </div>
                        <timer
                          class="flex-row"
                          color="info"
                          :time="course.available_at"
                          v-model="availableAtTimer"
                        />
                      </div>
                    </div>
                    <div
                      v-show="
                        !course.bought &&
                        course.can_buy &&
                        !availableAtTimer &&
                        unavailableAtTimer
                      "
                    >
                      <div
                        class="d-flex justify-content-sm-between justify-content-center w-100 flex-wrap my-25 font-weight-bold text-danger"
                      >
                        <div class="my-25">
                          زمان باقی مانده تا پایان مهلت ثبت نام :
                        </div>
                        <timer
                          class="flex-row"
                          color="danger"
                          :time="course.unavailable_at"
                          v-model="unavailableAtTimer"
                        />
                      </div>
                    </div>
                  </div>
                </b-media-body>
              </b-media>
              <b-skeleton
                width="100%"
                height="300px"
                v-if="loading"
              ></b-skeleton>
              <div class="pt-xl-2 pt-0" v-else-if="course.brief_description">
                <span class="font-weight-bold h5 d-sm-flex d-none"
                  >توضیحات</span
                >
                <div
                  v-html="course.brief_description"
                  class="text-justify py-1"
                />
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col>
        <div v-if="loading">
          <div class="d-flex justify-content-center w-100">
            <b-skeleton width="100px" height="30px" class="mx-2"></b-skeleton>
            <b-skeleton width="100px" height="30px" class="mx-2"></b-skeleton>
            <b-skeleton width="100px" height="30px" class="mx-2"></b-skeleton>
          </div>
          <b-skeleton width="100%" height="300px"></b-skeleton>
        </div>
        <course-tabs :course="course" v-else />
      </b-col>
      <b-col cols="12" class="d-flex d-md-none">
        <sidebar
          :loading="loading"
          :topics="topics"
          :course="course"
          class="w-100"
        />
      </b-col>

      <b-modal
        v-model="visible"
        hide-footer
        size="sm"
        centered
        v-if="course.has_penalty"
      >
        <b-alert variant="danger" show>
          <div class="alert-body">
            <p>
              <span
                >دسترسی شما به دلیل وجود جریمه پرداخت نشده مسدود شده است. برای مشاهده
                جریمه های خود به صفحه ی
                <b-link class="text-primary" :to="{ name: 'profile-penalties' }"
                  >جریمه ها</b-link
                >
                مراجعه کنید.
              </span>
            </p>
          </div>
        </b-alert>
      </b-modal>
    </b-row>
    <b-row
      v-if="userData.permissions && userData.permissions.permissions.length"
    >
      <b-col cols="12">
        <course-statistics @userCount="getUserCount" />
      </b-col>
      <b-col cols="12" sm="4" class="mb-1">
        <user-of-course :unic_students="unicStudent" :students="student" />
      </b-col>
      <b-col cols="12" sm="8" class="mb-sm-1 mb-5">
        <latest-login />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BImg,
  BBadge,
  BMedia,
  BMediaBody,
  BButton,
  BSkeleton,
  BAlert,
  VBModal,
  BModal,
  BLink,
} from "bootstrap-vue";
import CourseTabs from "./course-tabs/CourseTabs.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Loader from "@core/components/loader/Loader.vue";
import Timer from "@core/components/timer/Timer.vue";
import Sidebar from "../Sidebar.vue";
import CourseProgress from "./CourseProgress.vue";
import latestLogin from "../../../dashboard/latestLogin.vue";
import courseStatistics from "./CourseStatistics.vue";
import userOfCourse from "./userOfCourse.vue";
export default {
  components: {
    BRow,
    BCol,
    BMedia,
    BMediaBody,
    BSkeleton,
    BCard,
    BImg,
    BBadge,
    CourseTabs,
    BImg,
    BButton,
    Loader,
    Timer,
    Sidebar,
    BAlert,
    BModal,
    BLink,
    CourseProgress,
    latestLogin,
    courseStatistics,
    userOfCourse,
  },
  props: {
    course: {
      type: Object,
      default: () => {},
    },
    topics: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {
      loader: false,
      availableAtTimer: true,
      unavailableAtTimer: true,
      student: 0,
      unicStudent: 0,
    };
  },
  computed: {
    finalAmount() {
      let finalAmount = 0;
      if (this.course.percentage) {
        finalAmount =
          Number(this.course.amount) -
          (Number(this.course.amount) * Number(this.course.rebate)) / 100;
      } else {
        finalAmount = Number(this.course.amount) - Number(this.course.rebate);
      }

      return finalAmount > 0 ? String(parseInt(finalAmount)) : "0";
    },
    userData() {
      return this.$store.state.auth.userData || {};
    },
  },
  methods: {
    async checkout() {
      if (Object.keys(this.userData).length) {
        this.loader = true;
        try {
          const { data } = await this.$http.post("/panel/invoices", {
            items: [
              {
                model: {
                  id: this.$route.params.id,
                  type: "course",
                },
              },
            ],
          });
          this.loader = false;

          this.$router.push({
            name: "checkout",
            query: {
              invoice_id: data.data.id,
            },
          });
        } catch (err) {
          this.loader = false;
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: `مشکلی پیش آمده است.`,
                icon: "InfoIcon",
                variant: "danger",
              },
            },
            { position: "bottom-right" }
          );
        }
      } else {
        localStorage.setItem("invoice", this.$route.params.id);
        this.$router.push("/login");
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              duration: 100000,
              title: `لطفا برای خرید دوره وارد حساب کاربری خود شوید`,
              icon: "InfoIcon",
              variant: "danger",
            },
          },
          { position: "bottom-right" }
        );
      }
    },
    getUserCount(val) {
      (this.student = val[0]), (this.unicStudent = val[1]);
    },
  },
  watch: {
    async course(val) {
      val.has_penalty && (this.visible = true);
    },
  },
};
</script>
